import { createContext } from "react";

const UserPersonalizedFilterContext = createContext({});

export default UserPersonalizedFilterContext;
